import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CommonFunctionsService } from 'src/app/service/common-functions.service';
import {SharedDataService} from "../../../service/shared-data.service";

@Component({
  selector: 'app-passw-set-success',
  templateUrl: './passw-set-success.component.html',
  styleUrls: ['./passw-set-success.component.scss'],
})
export class PasswSetSuccessComponent implements OnInit {
  requestId!: string;
  buttonOptions: any = {
    backToLogin: {
      color: 'accent',
      text: 'BACK_TO_LOGIN',
      alignment: 'right',
      type: 'proceed',
      underline: 'none'
    }
  }
  isAppUser: boolean = false;

  constructor(private route: ActivatedRoute, public commonFunc: CommonFunctionsService, private _dataService: SharedDataService,) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.requestId = params.requestId || null;
    });

      // acid custom only get location if not app user
      this._dataService._getIsAppUser().subscribe(data => {
          if (data) {
              this.isAppUser = true;
          }
      });
  }

  globusCustomLoginRedirect(): void {
      if(this.isAppUser) {
          this.commonFunc.getRedirectedByRequestId();
          // window.location.href = 'https://app.globus-baumarkt.de/loginReturn' // removed due to 400 token srv in app
      } else {
          window.location.href = '/account/login'
      }
  }
}
